import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { CodependentHandbookProps } from "../modals/modalBuilder";
import { Billing, BillingType } from "@/api/billing";
import { useMemo } from "react";

export function NewDepositeHandbook(
  props: CodependentHandbookProps & AutocompleteProps<Billing>,
) {
  const items = useAppSelector((state) => state.handbooks.deposits);

  const finalItems = useMemo(() => {
    const [renter] = props.deps;

    return items.filter(
      (p) => p.payer == +renter && p.type == BillingType.Deposite,
    );
  }, [props.deps, items]);

  return (
    <Autocomplete
      defaultItems={finalItems}
      label="Депозит"
      placeholder="Выберите платёж по депозиту"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>{item.number}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
